import { axios, BaseService } from '@/pigeonline/wrapper';
import { app } from '@/main.js';

export default class AutoService extends BaseService {
  async autoAnalysis(request) {
    try {
      const URL =
        app.config.globalProperties.$base_URL + '/analysis/auto_analysis/run_auto_analysis';
      const response = await axios.post(`${URL}`, request, {
        headers: this.getAuthHeader(),
      });
      return response.data;
    } catch (e) {
      throw new Error('autoService.js:autoAnalysis ' + e.message);
    }
  }
  async analysisSummary(request) {
    try {
      const URL =
        app.config.globalProperties.$base_URL + '/analysis/auto_analysis/fetch_project_summary';
      const response = await axios.post(`${URL}`, request, {
        headers: this.getAuthHeader(),
      });
      return response.data;
    } catch (e) {
      throw new Error('autoService.js:analysisSummary ' + e.message);
    }
  }
  async generateObservations(request) {
    try {
      const URL =
        app.config.globalProperties.$base_URL + '/analysis/auto_analysis/generate_observations';
      const response = await axios.post(`${URL}`, request, {
        headers: this.getAuthHeader(),
      });
      return response.data;
    } catch (e) {
      throw new Error('autoService.js:generateObservations ' + e.message);
    }
  }
}
